module.exports = __webpack_public_path__ + "img/playStore.16a8ab60.png";